import { render, staticRenderFns } from "./inquiryadmin.vue?vue&type=template&id=85e60f40&scoped=true&"
import script from "./inquiryadmin.vue?vue&type=script&lang=js&"
export * from "./inquiryadmin.vue?vue&type=script&lang=js&"
import style0 from "./inquiryadmin.vue?vue&type=style&index=0&id=85e60f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e60f40",
  null
  
)

export default component.exports